import * as actionTypes from './types';
import { SubmissionError } from 'redux-form';
import {
  searchSubs,
  searchAttSubs,
  searchTracfoneSubs,
  searchSimoSubs,
  searchQuickSubs,
} from '../api';
import { sortSubs } from '../helpers/subs';

export const searchAllSubs = (search) => async (dispatch) => {
  const pageSize = 100;
  const page = 1;
  const carriersToApi = {
    att: searchAttSubs,
    simo: searchSimoSubs,
    sprint: searchSubs,
    tracfone: searchTracfoneSubs,
    quick: searchQuickSubs,
  };
  let allSubs = [];
  const promisedRequests = [];

  for (let carrier in carriersToApi) {
    let subApiCall = carriersToApi[carrier];
    let ordering = search.ordering;

    if (ordering === 'status' || ordering === '-status') {
      ordering =
        ordering[0] === '-' ? `-${carrier}_status` : `${carrier}_status`;
    }

    let transformedSearch = { ...search, ordering };

    //skip all carrier if search contains att field
    if (carrier !== 'att' && transformedSearch['imsi']) {
      continue;
    }

    if (carrier === 'simo') {
      const availableFields = [
        'first_name',
        'last_name',
        'device_id',
        'user_profile',
      ];
      const notSimoFields = ['icc_id', 'mdn', 'imsi'];
      // no search fields for simo case
      if (notSimoFields.some((field) => transformedSearch[field])) {
        continue;
      }

      // no search fields for simo case
      if (!availableFields.some((field) => transformedSearch[field])) {
        continue;
      }

      if (transformedSearch.device_id) {
        transformedSearch.device_sn = transformedSearch.device_id;
        delete transformedSearch.device_id;
      }
    }

    promisedRequests.push(subApiCall(page, transformedSearch, pageSize));
  }

  return Promise.all(promisedRequests)
    .then((results) => {
      for (let response of results) {
        const subs = response.data.results;
        allSubs = allSubs.concat(subs);
      }
      dispatch({
        type: actionTypes.GET_ALL_CARRIERS_SUBS_WITHOUT_LAYOVER,
        payload: sortSubs(allSubs, search.ordering),
      });
    })
    .catch((e) => {
      let messages = e.response
        ? e.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError({
        _error: messages,
      });
    });
};

export const fetchAllUserSubs = (userId) => async (dispatch) => {
  const searchSubsApis = [searchSubs, searchAttSubs, searchTracfoneSubs];
  let subs = [];

  for (let searchSubsApi of searchSubsApis) {
    let page = 1;
    let next = 'next-url';

    while (next) {
      let response;

      try {
        response = await searchSubsApi(page, { user_profile: userId });
      } catch (e) {
        let messages = e.response
          ? e.response.data
          : { detail: 'Something went wrong' };
        throw new SubmissionError({
          _error: messages,
        });
      }

      subs = subs.concat(response.data.results);
      next = response.data.next;
      page += 1;
    }
  }

  dispatch({
    type: actionTypes.GET_ALL_USER_SUBS,
    payload: subs,
    userId,
  });

  return subs;
};
